module.exports = __webpack_public_path__ + "static/media/go2.4ac972dc.jpg";